import clsx from 'clsx'
import { ReactNode, useEffect, useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { useIsMobile } from 'web/hooks/use-is-mobile'
import { useTracking } from 'web/hooks/use-tracking'
import { GoogleOneTapLogin } from 'web/lib/firebase/google-onetap-login'
import { ConfettiOnDemand } from '../confetti-on-demand'
import { BottomNavBar } from '../nav/bottom-nav-bar'
import { TopHeader, CategoryNav } from '../nav/top-header'
import { Col } from './col'

import { Footer } from '../footer'
import { FirstStreakModalManager } from '../profile/first-streak-modal'

export function Page(props: {
  trackPageView: string | false
  trackPageProps?: Record<string, any>
  className?: string
  children?: ReactNode
  hideSidebar?: boolean
  hideBottomBar?: boolean
  hideFooter?: boolean
  hideHeader?: boolean
  hideCategoryNav?: boolean
  banner?: ReactNode
}) {
  const {
    trackPageView,
    trackPageProps,
    children,
    className,
    hideBottomBar,
    hideHeader,
    hideCategoryNav,
    banner,
  } = props

  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (trackPageView) useTracking(`view ${trackPageView}`, trackPageProps)
  const isMobile = useIsMobile()

  const [isIOS, setIsIOS] = useState(false)
  useEffect(() => {
    // Only use scroll container on iOS
    const iosCheck =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
    setIsIOS(iosCheck)
  }, [])

  return (
    <>
      <ConfettiOnDemand />
      <GoogleOneTapLogin className="fixed bottom-12 right-4 z-[1000]" />
      <FirstStreakModalManager />

      {/* Polymarket-style top header */}
      {!hideHeader && <TopHeader />}
      {!hideHeader && !hideCategoryNav && <CategoryNav />}

      <Col
        className={clsx(
          !hideBottomBar && 'pb-[58px] lg:pb-0', // bottom bar padding
          'text-ink-1000 mx-auto min-h-screen w-full bg-canvas-0',
          isMobile && isIOS && 'page-scroll-container' // Add scrollable container only on iOS
        )}
        style={{ maxWidth: '1350px' }}
      >
        <Toaster
          position={isMobile ? 'bottom-center' : 'top-center'}
          containerClassName="!bottom-[70px]"
        />
        <main
          className={clsx('flex flex-1 flex-col px-4 py-4 lg:px-6', className)}
        >
          {banner}
          {children}
          {!props.hideFooter && <Footer />}
        </main>
      </Col>
      {!hideBottomBar && <BottomNavBar />}
    </>
  )
}
